<template>
  <div>
    <GlobalLoader></GlobalLoader>
    <router-view></router-view>
  </div>
</template>

<script>
  import GlobalLoader from './components/layout/GlobalLoader.vue';

  export default {
    name: 'App',
    components: {
      GlobalLoader,
    },
  };
</script>
